import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FieldPasswordTag from '@/modules/admin/components/FieldPassword/FieldPasswordTag';
import Password from '@/modules/authentication/components/Password';

const FieldPassword = (props) => {
  const { t } = useTranslation('admin');
  const [isEditing, setIsEditing] = useState();
  
  return <div>
    {
      isEditing
        ? <Password
          lateral={false}
          size={'large'}
          placeholder={t('user.form.password.placeholder')}
          {...props}
        />
        : <FieldPasswordTag onClick={() => setIsEditing(true)}/>
    }
  </div>;
};

export default FieldPassword;

export const renderFieldPassword = (props) => <FieldPassword {...props}/>;
